import {FC, ReactNode} from 'react'
import styles from './styles.module.scss'

type BadgeProps = {
  children: ReactNode
  className?: string
  type?: 'text' | 'red' | 'blue'
}

export const Badge: FC<BadgeProps> = ({children, className, type}) => {
  return (
    <div className={`${styles.badge} ${className || ''} ${styles[type || 'text']}`}>
      {children}
    </div>
  )
}